export default "__VITE_ASSET__1IOn7Z9Y__"